import { IconButton, Menu, MenuItem } from "@/components/ui";
import { useState, useRef } from "react";

interface MenuButtonProps {
  menuItems: {
    label: string;
    onClick: ((e: React.MouseEvent<Element, MouseEvent>) => void) | (() => void);
  }[];
  buttonContent: string | React.ReactNode;
  size?: "sm" | "md" | "lg";
}

function MenuButton({
  menuItems,
  buttonContent,
  size = "md",
}: MenuButtonProps) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="relative">
      <IconButton
        ref={buttonRef}
        onClick={handleClick}
        size={size}
        variant="ghost"
      >
        {buttonContent}
      </IconButton>
      <Menu
        open={open}
        onClose={handleClose}
        anchorEl={buttonRef.current}
      >
        {menuItems.map((item, index) => (
          <MenuItem
            key={index}
            onClick={(e) => {
              item.onClick(e);
              handleClose();
            }}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}

export default MenuButton;
